import 'fastdom';

const fastdomPromisedLib = require('../../lib/fastdom-promised');

// @ts-ignore
export const fastdomPromised = window.fastdom.extend(fastdomPromisedLib);

